import React from 'react';
import { SystemThemeProvider } from "../../hooks/useThemeProvider";
var ThemeProvider = /*#__PURE__*/React.memo(function (_ref) {
  var _prevValue$custom, _value$custom;

  var children = _ref.children,
      value = _ref.value;
  var themeValue = React.useRef(value);
  var prevValue = themeValue.current;

  if (prevValue.system !== value.system || prevValue.branding !== value.branding || ((_prevValue$custom = prevValue.custom) === null || _prevValue$custom === void 0 ? void 0 : _prevValue$custom.namespace) !== ((_value$custom = value.custom) === null || _value$custom === void 0 ? void 0 : _value$custom.namespace)) {
    themeValue.current = value;
  }

  return /*#__PURE__*/React.createElement(SystemThemeProvider, {
    value: themeValue.current
  }, children);
});
ThemeProvider.displayName = 'ThemeProvider';
export default ThemeProvider;